/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';

const state = {
  service_status_list: [
    {
      progress: 'created',
      code: 'created',
      title: 'Criada',
      color: '#48B38B',
      description: 'Criada'
    },
    {
      progress: 'waiting_for_start',
      code: 'waiting_approval',
      title: 'Aguardando aprovação',
      color: '#546E7A',
      description: 'Aguardando aprovação do cliente'
    },
    {
      progress: 'working',
      code: 'paused',
      title: 'Pausada',
      color: '#F9A825',
      description: 'Pausada'
    },
    {
      progress: 'waiting_for_start',
      code: 'approved',
      title: 'Aprovada',
      color: '#48B38B',
      description: 'Aprovada'
    },
    {
      progress: 'waiting_for_start',
      code: 'waiting_execution',
      title: 'Aguardando início',
      color: '#546E7A',
      description: 'Aguardando início'
    },
    {
      progress: 'working',
      code: 'working',
      title: 'Trabalhando',
      color: '#0097A7',
      description: 'Trabalhando'
    },
    {
      progress: 'waiting_for_delivery',
      code: 'waiting_delivery',
      title: 'Aguardando entrega',
      color: '#546E7A',
      description: 'Aguardando entrega'
    },
    {
      progress: 'finished',
      code: 'finished',
      title: 'Finalizada',
      color: '#48B38B',
      description: 'Finalizada'
    },
    {
      progress: 'canceled',
      code: 'canceled',
      title: 'Cancelada',
      color: '#212121',
      description: 'Cancelada'
    }
  ],
  differentials: [
    {
      icon: 'mdi-shield-check',
      description: 'Relatório completo do serviço',
      order: 0
    },
    {
      icon: 'mdi-handshake-outline',
      description: 'Atendimento diferenciado',
      order: 1
    },
    {
      icon: 'mdi-clock-check',
      description: 'Sala de espera',
      order: 2
    },
    {
      icon: 'mdi-car-wash',
      description: 'Lava-rápido',
      order: 3
    },
    {
      icon: 'mdi-car-arrow-left',
      description: 'Leva e Traz',
      order: 4
    },
    {
      icon: 'mdi-wifi-check',
      description: 'Wi-Fi',
      order: 5
    },
    {
      icon: 'mdi-coffee',
      description: 'Café',
      order: 6
    }
  ],
  services: [
    {
      description: 'Airbag',
      order: 0
    },
    {
      description: 'Alternador',
      order: 1
    },
    {
      description: 'Amortecedores',
      order: 2
    },
    {
      description: 'Balanceamento',
      order: 3
    },
    {
      description: 'Bomba de Combustível',
      order: 4
    },
    {
      description: 'Cabos de Velas',
      order: 5
    },
    {
      description: 'Caixa de Direção',
      order: 6
    },
    {
      description: 'Carga de Gás',
      order: 7
    },
    {
      description: 'Correia Dentada',
      order: 8
    },
    {
      description: 'Câmbio Automatizado',
      order: 9
    },
    {
      description: 'Câmbio Automático',
      order: 10
    },
    {
      description: 'Câmbio Manual',
      order: 11
    },
    {
      description: 'Diagnóstico Automotivo',
      order: 12
    },
    {
      description: 'Direção Elétrica',
      order: 13
    },
    {
      description: 'Direção Hidráulica',
      order: 14
    },
    {
      description: 'Direção Mecânica',
      order: 15
    },
    {
      description: 'Elétrica em Geral',
      order: 16
    },
    {
      description: 'Embreagem',
      order: 17
    },
    {
      description: 'Freios',
      order: 18
    },
    {
      description: 'Funilaria e Pintura',
      order: 19
    },
    {
      description: 'Hidratação de Banco de Couro',
      order: 20
    },
    {
      description: 'Higienização de Ar Condicionado',
      order: 21
    },
    {
      description: 'Higienização de Bancos',
      order: 22
    },
    {
      description: 'Injeção Eletrônica',
      order: 23
    },
    {
      description: 'Instalação de Ar Condicionado',
      order: 24
    },
    {
      description: 'Insulfilm',
      order: 25
    },
    {
      description: 'Junta Homocinética',
      order: 26
    },
    {
      description: 'Lavagem Automotiva',
      order: 27
    },
    {
      description: 'Limpeza de Bicos Flex',
      order: 28
    },
    {
      description: 'Limpeza de Radiador',
      order: 29
    },
    {
      description: 'Manutenção de Ar Condicionado',
      order: 30
    },
    {
      description: 'Martelinho de Ouro',
      order: 31
    },
    {
      description: 'Mecânica Diesel Leve',
      order: 32
    },
    {
      description: 'Mecânica em Geral',
      order: 33
    },
    {
      description: 'Micropintura',
      order: 34
    },
    {
      description: 'Montagem de Motor',
      order: 35
    },
    {
      description: 'Motor de Partida',
      order: 36
    },
    {
      description: 'Máquina de Vidro Manual',
      order: 37
    },
    {
      description: 'Polimento de Farol',
      order: 38
    },
    {
      description: 'Polimento e Cristalização',
      order: 39
    },
    {
      description: 'Polimento e Espelhamento',
      order: 40
    },
    {
      description: 'Polimento e Vitrificação',
      order: 41
    },
    {
      description: 'Radiador',
      order: 42
    },
    {
      description: 'Recuperação de Para-choque',
      order: 43
    },
    {
      description: 'Regulagem Eletrônica',
      order: 44
    },
    {
      description: 'Restauração Automotiva',
      order: 45
    },
    {
      description: 'Rodízio de Pneus',
      order: 46
    },
    {
      description: 'Suspensão',
      order: 47
    },
    {
      description: 'Trava Elétrica',
      order: 48
    },
    {
      description: 'Troca de Óleo',
      order: 49
    },
    {
      description: 'Troca de Óleo de Câmbio Automático',
      order: 50
    },
    {
      description: 'Velas de Ignição',
      order: 51
    },
    {
      description: 'Vidro Elétrico',
      order: 52
    },
    {
      description: 'Alinhamento',
      order: 53
    },
    {
      description: 'Revisão',
      order: 54
    },
    {
      description: 'Alinhamento de Farol',
      order: 55
    },
    {
      description: 'Cambagem',
      order: 56
    },
    {
      description: 'Cristalização de Vidros',
      order: 57
    },
    {
      description: 'Retífica de Cabeçote',
      order: 58
    },
    {
      description: 'Retífica de Câmbio',
      order: 59
    },
    {
      description: 'Retífica de Freio',
      order: 60
    },
    {
      description: 'Retífica de Motor',
      order: 61
    }
  ],
  payment_methods: [
    {
      description: 'Dinheiro',
      value: 'money'
    },
    {
      description: 'Débito',
      value: 'debit'
    },
    {
      description: 'Crédito',
      value: 'credit'
    },
    {
      description: 'Boleto',
      value: 'ticket'
    }
  ]
};

const getters = {
  organization_status_list: (state) => state.service_status_list,
  organization_differentials: (state) => state.differentials,
  organization_services: (state) => state.services,
  organization_payment_methods: (state) => state.payment_methods
};

const mutations = {
  SET_STATUS_LIST(state, serviceStatusList) {
    state.service_status_list = serviceStatusList;
  }
};

const actions = {
  getStatusList({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .get('/organization/status')
        .then((response) => {
          if (response.data && response.data.length > 0) {
            commit('SET_STATUS_LIST', response.data);
          }
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
